import React, {useEffect} from 'react';
import './App.css';
import { Authenticator } from "./components/Authenticator";
import {Configuration} from "./Configuration";
import Layout from "./Layout";
import {Route, Routes } from "react-router-dom";
import { Chat } from "./views/Chat";

const AppRoutes = [
    {
        path: "/",
        index: true,
        element: <Chat />,
    }
];

const App = () => {
    // console.log("REACT_APP_AUTHORITY_URL", Configuration.authorityUrl)
    // console.log("REACT_APP_API_URL", Configuration.baseApiUrl);

    // useEffect(() => {
    //     const sessionKey = 'app_session_id';
    //     const currentTabId = window.name;
    //     const storedTabId = sessionStorage.getItem(sessionKey);
    //
    //     console.log("App start", currentTabId);
    //     if (storedTabId && currentTabId !== storedTabId) {
    //         console.warn("Duplicate tab detected.");
    //         sessionStorage.clear(); 
    //         window.location.reload();
    //     } else {
    //         const newId = Math.random().toString();
    //         window.name = newId;
    //         sessionStorage.setItem(sessionKey, newId);
    //     }
    // }, []);


    return (
        <Authenticator authConfig={Configuration.authenticationConfig}>
            <Layout>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const {element, ...rest} = route;
                        return <Route key={index} {...rest} element={element}/>;
                    })}
                </Routes>
            </Layout>
        </Authenticator>
    );
};

export default App;